const eventOnboardingSteps = [
  {
    name: 'userAndPromoter',
    path: 'user-and-promoter',
    label: 'User & Promoter Information',
  },
  { name: 'about', path: 'about', label: 'About Event' },
  { name: 'whereWhen', path: 'where-when', label: 'Where and When?' },
  { name: 'artWork', path: 'art-work', label: 'Art work' },
  { name: 'links', path: 'links', label: 'Links' },
  { name: 'preview', path: 'preview', label: 'Review your information' },
  { name: 'thankYou', path: 'thank-you', label: 'Thank you' },
];

export const getNextStep = (currentStep: string): string | undefined => {
  const currentIndex = eventOnboardingSteps.findIndex((step) => step.path === currentStep);
  return eventOnboardingSteps[currentIndex + 1]?.path;
};

export const getCurrentStepInfo = (currentStep: string) => {
  const currentIndex = eventOnboardingSteps.findIndex((step) => step.path === currentStep);
  return {
    currentStep: currentIndex + 1,
    // -1 because the last page has no stepper
    totalSteps: eventOnboardingSteps.length - 1,
    label: eventOnboardingSteps[currentIndex]?.label,
  };
};
